import { render, staticRenderFns } from "./VideoTile.vue?vue&type=template&id=0ea2c133&scoped=true"
import script from "./VideoTile.vue?vue&type=script&lang=js"
export * from "./VideoTile.vue?vue&type=script&lang=js"
import style0 from "./VideoTile.vue?vue&type=style&index=0&id=0ea2c133&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea2c133",
  null
  
)

export default component.exports